export default "/images/CIDOB_logo.png?d0356786a8cec3af5435bfea924c2c59";